import Vue from 'vue'
import VueRouter from 'vue-router'
import Agent from '../library/userAgentHelper'
import eventsRouter from "./events";
import scan from "./scan";
import broker from "./broker";
import brandCustom from "./brandCustom";
import axios from 'axios'
import qs from 'qs'

Vue.use(VueRouter);

let router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: '/find'
    },
    {
      path: '/',
      name: 'index',
      meta: {
        titleBackup: '租房'
      },
      component: () => System.import('@/pages/homePage/index'),
      children: [
        {
          path: 'find',
          name: 'find',
          meta: {
            title: '找房'
          },
          component: () => {
            if (Agent.browser === 'unionpay') {
              return System.import('@/pages/homePage/unionpay/find');
            } else {
              return System.import('@/pages/homePage/find');
            }
          }
        },
        {
          path: '/hometravel',
          name: 'hometravel',
          meta: {
            title: '看房行程'
          },
          component: () => System.import("@/pages/travel")
        },
        {
          path: 'my',
          name: 'my',
          meta: {
            title: '我的'
          },
          component: () => System.import('@/pages/homePage/my')
        },
        {
          path: 'myset',
          name: 'myset',
          meta: {
            title: '设置'
          },
          component: () => System.import('@/pages/homePage/mySetting')
        }
      ]
    },
    {
      path: '/:city?/cityMenu',
      name: 'cityMenu',
      meta: {
        title: '选择城市'
      },
      component: () => System.import('@/pages/cityMenu/index')
    },
    {
      path: '/order',
      name: '/order',
      meta: {
        title: '预约看房'
      },
      component: () => System.import('@/pages/order')
    },
    {
      path: '/order/orderSuccess',
      name: '/order/orderSuccess',
      meta: {
        title: '预约成功'
      },
      component: () => System.import('@/pages/order/orderSuccess')
    },
    {
      path: '/myOrder',
      name: '/myOrder',
      meta: {
        title: '我的预约'
      },
      component: () => System.import('@/pages/myOrder')
    },
    {
      path: '/roomDetail/:id',
      name: 'roomDetail',
      meta: {
        titleBackup: '蘑菇租房经纪人房间详情'
      },
      component: () => System.import('@/pages/roomDetail')
    },
    {
      path: '/roomDetail',
      name: 'roomDetail2',
      meta: {
        titleBackup: '蘑菇租房经纪人房间详情'
      },
      beforeEnter(to, from, next) {
        if (to.query.id) {
          next("/roomDetail/" + to.query.id)
        } else {
          next("/404")
        }
      }
    },
    {
      path: '/detail/:roomId/:sourceType',
      name: 'detail',
      meta: {
        titleBackup: '蘑菇租房房间详情'
      },
      component: () => System.import('@/pages/houseDetailV2')
    },
    {
      path: '/report',
      name: 'report',
      meta: {
        title: '举报投诉-蘑菇租房'
      },
      component: () => System.import('@/pages/report')
    },
    {
      path: '/listBroker',
      name: 'listBroker',
      meta: {
        titleBackup: '业主、经纪人房源',
        keepAlive: true
      },
      component: () => System.import('@/pages/houseList/index')
    },
    {
      path: '/listLandlord',
      name: 'listLandlord',
      meta: {
        titleBackup: '品牌公寓房源列表页',
        keepAlive: true
      },
      component: () => System.import('@/pages/houseList/index')
    },
    {
      path: '/list',
      name: 'list',
      meta: {
        titleBackup: '房源列表页',
        keepAlive: true
      },
      component: () => System.import('@/pages/roomList/index')
    },
    {
      path: '/creditList',
      name: 'creditList',
      meta: {
        titleBackup: '信用租',
        keepAlive: true
      },
      component: () => System.import('@/pages/houseList/credit_indexList')
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: '蘑菇租房搜索'
      },
      component: () => System.import('@/pages/search')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: '加盟蘑菇经纪人'
      },
      component: () => System.import('@/pages/register/sign')
    },
    {
      path: '/register/download',
      name: 'download',
      meta: {
        title: '加盟蘑菇经纪人'
      },
      component: () => System.import('@/pages/register/download')
    },
    {
      path: '/register/app',
      name: 'app',
      meta: {
        title: '加盟蘑菇经纪人'
      },
      component: () => System.import('@/pages/register/app')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: () => System.import('@/pages/login')
    },
    {
      path: '/login/protocol(.html)?',
      name: 'protocol',
      meta: {
        title: '用户使用条款和隐私声明'
      },
      component: () => System.import('@/pages/login/protocol')
    },
    // 官网、银联房间详情
    {
      path: '/houseDetail/:roomId',
      name: 'houseDetail',
      meta: {
        titleBackup: '房间详情页'
      },
      component: () => System.import('@/pages/houseDetailV2')
    },
    {
      path: '/houseDetail',
      name: 'houseDetail2',
      meta: {
        titleBackup: '房间详情页'
      },
      beforeEnter(to, from, next) {
        if (to.query.id) {
          next("/houseDetail/" + to.query.id)
        } else {
          next("/404")
        }
      }
    },
    {
      path: '/insurance',
      name: 'insurance',
      meta: {
        title: '免费赠险'
      },
      component: () => System.import('@/pages/Insurance')
    },
    {
      path: '/couponBag',
      name: 'couponBag',
      meta: {
        title: '我的卡包'
      },
      component: () => System.import('@/pages/coupon/bag')
    },
    {
      path: '/couponDetail',
      name: 'couponDetail',
      meta: {
        title: '我的卡券'
      },
      component: () => System.import("@/pages/coupon/detail")
    },
    {
      path: '/collection/broker',
      name: 'broker',
      component: () => System.import("@/pages/collection")
    },
    // todo 兼容支付宝小程序城市切换
    {
      path: '/:city/collection/broker',
      name: 'brokerCity',
      component: () => System.import("@/pages/collection")
    },
    {
      path: '/collection/brokerApp',
      name: 'brokerApp',
      component: () => System.import("@/pages/collection/indexApp")
    },
    {
      path: '/collection/landlord',
      name: 'landlord',
      meta: {
        title: '公寓房源'
      },
      component: () => System.import("@/pages/collection/landlord")
    },
    {
      path: '/brand',
      name: 'brand',
      meta: {
        title: '品牌公寓'
      },
      component: () => System.import("@/pages/brand/index")
    },
    {
      path: '/shop',
      name: 'shop',
      meta: {
        title: ''
      },
      component: () => System.import("@/pages/brand/landlord")
    },
    // todo 兼容支付宝小程序城市切换
    {
      path: '/:city/brand',
      name: 'brandCity',
      meta: {
        title: '品牌公寓'
      },
      component: () => System.import("@/pages/brand/index")
    },
    {
      path: '/landlord',
      name: 'apartment',
      meta: {
        titleBackup: '普通公寓店铺页',
        keepAlive: true
      },
      component: () => System.import('@/pages/apartment/index')
    },
    // todo 兼容支付宝小程序城市切换
    {
      path: '/:city/landlord',
      name: 'apartmentCity',
      meta: {
        titleBackup: '普通公寓店铺页',
        keepAlive: true
      },
      component: () => System.import('@/pages/apartment/index')
    },
    {
      path: '/brand/brandList',
      name: 'brandList',
      meta: {
        title: '品牌公寓优选'
      },
      component: () => System.import("@/pages/brand/brandList")
    },
    // 蘑菇头条
    {
      path: '/topLine',
      name: 'topLine',
      meta: {
        title: '蘑菇头条'
      },
      component: () => System.import("@/pages/topLine/topLine")
    },
    // 头条资讯详情
    {
      path: '/lineDetail',
      name: 'lineDetail',
      meta: {
        title: '资讯详情'
      },
      component: () => System.import("@/pages/topLine/lineDetail")
    },
    {
      path: '/404',
      name: '404',
      meta: {
        title: '租房404'
      },
      component: () => System.import("@/pages/404")
    },
    {

      path: '/(pay/)?console',
      name: 'console',
      meta: {
        title: '控制台'
      },
      component: () => System.import("@/pages/console")
    },
    {
      path: '/travel',
      name: 'travel',
      meta: {
        title: '看房行程'
      },
      component: () => System.import("@/pages/travel")
    },
    {
      path: '/travel/history',
      name: 'travelHistory',
      meta: {
        title: '看房历史'
      },
      component: () => System.import("@/pages/travel/history")
    },
    {
      path : "*",
      beforeEnter(to, from, next) {
        next("/404")
      }
    },
    {
      path: '/:city/searchTraffic',
      name: 'searchTraffic',
      meta: {
        title: '交通找房',
        keepAlive: true
      },
      component: () => System.import("@/pages/searchTraffic/index")
    },
    {
      path: '/:city/searchTrafficMap',
      name: 'searchTrafficMap',
      meta: {
        title: '线路'
      },
      component: () => System.import("@/pages/searchTrafficMap/index")
    },
    {
      path: '/:city/searchMap',
      name: 'searchMap',
      meta: {
        title: '地图找房',
        keepAlive: true
      },
      component: () => System.import("@/pages/searchMap/index")
    },
    {
      path: '/homeBody',
      name: 'homeBody',
      meta: {
        title: 'homeBody'
      },
      component: () => System.import("@/pages/homePage/homeBody")
    },
    {
      path: '/insuranceIntro',
      name: 'insuranceIntro',
      meta: {
        title: '押金无忧计划'
      },
      component: () => System.import("@/pages/zhonganInsurance/insuranceIntro")
    },
    {
      path: '/insuranceList',
      name: 'insuranceList',
      meta: {
        title: '我的保单'
      },
      component: () => System.import("@/pages/zhonganInsurance/insuranceList")
    }
  ].concat(eventsRouter).concat(scan).concat(brandCustom).concat(broker),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

//todo 兼容历史链接  用于拦截扫码进入url,匹配规则进行分发
router.beforeEach((to, from, next) => {
  let isH5Sign = to.path.indexOf('/mogoroom-renterembed-h5/sign') > -1;
  let isFeRepairList = to.path.indexOf('/mogoroom-renterembed-fe/dist/pages/repairList') > -1;
  let isFeSelfService = to.path.indexOf('/mogoroom-renterembed-fe/dist/pages/selfService') > -1;
  let isFe = to.path.indexOf('/mogoroom-renterembed-fe/') > -1;
  if(isH5Sign) {
    if(to.query['jumpUrl'] == 'orderList') {
      let query =  qs.stringify({
        landlordId: to.query['landlordId'] ,
        originId: to.query['originId']
      })
      window.location.replace(`/pay/leaseList?${query}`)
    } else {
      axios.get(`https://s.mgzf.com?jumpUrlCode=${location.href}`);
      window.location.replace(`/pay/leaseList`);
    }
  } else if(isFeRepairList) {
    window.location.replace("/leaseRepair/repairList");
  } else if(isFeSelfService) {
    window.location.replace("/pay/selfService");
  } else if(isFe) {
    window.location.replace("/pay/leaseList");
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js